import type { AnyAction, Dispatch } from 'redux';

import * as CreateOrganizationContactAPI from 'ab-api/web/organizationContact/createOrganizationContact';
import * as DeleteOrganizationContactAPI from 'ab-api/web/organizationContact/deleteOrganizationContact';
import * as FindOrganizationContactsAPI from 'ab-api/web/organizationContact/findOrganizationContacts';
import * as UpdateOrganizationContactAPI from 'ab-api/web/organizationContact/updateOrganizationContact';

import type { GetRootState } from 'af-reducers';

import { errorHandler } from 'af-utils/actions.util';
import { http } from 'af-utils/http.util';

import type { OrganizationNotificationType } from 'ab-enums/organizationNotificationType.enum';

export function findOrganizationContacts(type: OrganizationNotificationType) {
	return async (dispatch: Dispatch<AnyAction>, getState: GetRootState, { redirectTo }) => {

		const action = async () => {
			return await http
				.get<FindOrganizationContactsAPI.W_OrganizationContact_FindOrganizationContacts_VM>(
					FindOrganizationContactsAPI.URL(type)
				);
		};

		return await errorHandler(action, dispatch, redirectTo);
	};
}

export function createOrganizationContact(
	rm: CreateOrganizationContactAPI.W_OrganizationContact_CreateOrganizationContact_RM
) {
	return async (dispatch: Dispatch<AnyAction>, getState: GetRootState, { redirectTo }) => {

		const action = async () => {
			return await http.post(CreateOrganizationContactAPI.URL(), rm);
		};

		return await errorHandler(action, dispatch, redirectTo);
	};
}

export function updateOrganizationContact(
	id: number,
	rm: UpdateOrganizationContactAPI.W_OrganizationContact_UpdateOrganizationContact_RM
) {
	return async (dispatch: Dispatch<AnyAction>, getState: GetRootState, { redirectTo }) => {

		const action = async () => {
			return await http.put(UpdateOrganizationContactAPI.URL(id), rm);
		};

		return await errorHandler(action, dispatch, redirectTo);
	};
}

export function deleteOrganizationContact(organizationContactId: number) {
	return async (dispatch: Dispatch<AnyAction>, getState: GetRootState, { redirectTo }) => {

		const action = async () => {
			return await http.delete(DeleteOrganizationContactAPI.URL(organizationContactId));
		};

		return await errorHandler(action, dispatch, redirectTo);
	};
}
